// extracted by mini-css-extract-plugin
export default {"privacy":"ColorZone_privacy__CCGWs","listLink":"ColorZone_listLink__PsVC3"};